import { render, staticRenderFns } from "./ConsultarMatriz.vue?vue&type=template&id=5640f175&scoped=true&"
import script from "./ConsultarMatriz.vue?vue&type=script&lang=js&"
export * from "./ConsultarMatriz.vue?vue&type=script&lang=js&"
import style0 from "./ConsultarMatriz.vue?vue&type=style&index=0&id=5640f175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5640f175",
  null
  
)

export default component.exports